import { Component, OnDestroy, OnInit } from '@angular/core';
import { Chart } from 'chart.js/auto';
import 'chartjs-plugin-datalabels';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ChartData } from "../shared/chart-data.class";
import { ReportService } from '../shared/services/report.service';


@Component({
  selector: 'avs-dashboard-overview',
  templateUrl: './dashboard-overview.component.html',
  styleUrls: ['./dashboard-overview.component.css']
})

export class DashboardOverviewComponent implements OnInit, OnDestroy {
  public chartAssign: Chart | undefined;
  public chartUsed: Chart | undefined;
  public chartError: Chart | undefined;

  private chartAssignmentData = new ChartData({ name: 'Nicht zugewiesen', value: 200 }, { name: 'Zugewiesen', value: 300 })
  private chartWorkloadData = new ChartData({ name: 'Online', value: 600 }, { name: 'Offline', value: 600 })
  private chartErrorRateData = new ChartData({ name: 'Ok', value: 0 },{ name: 'Warnung', value: 0 }, { name: 'Fehler', value: 0 })

  public isChartAssignmentDataZero: boolean = false;
  public isChartWorkloadDataZero: boolean = false;
  public isChartErrorRateDataZero: boolean = false; /*  */
  constructor(private reportService: ReportService) { }

  public ngOnDestroy(): void {
    // Chart.js haelt pro Chart einen dokumentweiten MutationObserver — ohne
    // destroy() akkumulieren die Observer und bremsen jede DOM-aenderungsreiche Seite
    this.chartAssign?.destroy();
    this.chartUsed?.destroy();
    this.chartError?.destroy();
  }

  public ngOnInit() {
    this.getReports();
  }

  private getReports() {
    this.reportService.getAssignedReport().subscribe(x => {
      if (x) {
        this.chartAssignmentData.item1.value = x.unAssignedDevices;
        this.chartAssignmentData.item2.value = x.assignedDevices;
        if (x.totalDevices === 0) this.isChartAssignmentDataZero = true
      }
      this.createChartAssignment();
      if(x === null) { this.isChartAssignmentDataZero = true }
    })
    this.reportService.getRouteStationUsageReport().subscribe(x => {
      if (x) {
        this.chartWorkloadData.item1.value = x.totalOnlineDevices!;
        this.chartWorkloadData.item2.value = x.totalOfflineDevices!;
        /*    this.chartWorkloadData.item3!.value = x.offlineWithoutProject;
           this.chartWorkloadData.item4!.value = x.onlineWithoutProject; */

        if (x.totalDevices === 0) this.isChartWorkloadDataZero = true
      }
      this.createChartWorkload();
      if(x === null) { this.isChartWorkloadDataZero = true }
    })
    this.reportService.getRouteStationErrorOverview().subscribe(x => {
      if (x) {
        this.chartErrorRateData.item1.value = x.noError;
        this.chartErrorRateData.item2.value = x.warnings;
        this.chartErrorRateData.item3!.value = x.error;
        if (x.totalDevices === 0 ) this.isChartErrorRateDataZero = true
      }
      this.createChartErrorRate();
      if(x === null) { this.isChartErrorRateDataZero = true }
     
    })
  }

  private createChartAssignment() {
    this.chartAssign = new Chart('canvasAssignment', {
      type: 'doughnut',

      data: {
        labels: [this.chartAssignmentData.item2.name, this.chartAssignmentData.item1.name],
        datasets: [{
          data: [this.chartAssignmentData.item2.value, this.chartAssignmentData.item1.value],
          backgroundColor: [
            '#84c36c',
            '#d40c14',
        
          ],
          hoverBackgroundColor: [
            '#5ca43c',
            '#bc0404',
          
          ],
          hoverOffset: 0
        }],
      },
      options: {
        aspectRatio: 0.75,
        responsive: true,
        maintainAspectRatio: true,
        events: ['mousemove', 'mouseout', 'touchstart', 'touchmove'],
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
            },
          },
          datalabels: {
            font: {
              size: 13,
              weight: 'bold',
            },
            color: 'white',
            formatter: function (value: number, context: any) {
              const dataPoints = context.chart.data.datasets[0].data;
              function totalSum(total: number, datapoint: number) {
                return total + datapoint;
              }
              const totalValue = dataPoints.reduce(totalSum, 0);
              const percentageValue = (value / totalValue * 100).toFixed(1);

              return ` ${percentageValue}%`;
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });

  }

  public createChartErrorRate() {

    this.chartUsed = new Chart('canvasErrorRate', {
      type: 'doughnut',

      data: {
        labels: [this.chartErrorRateData.item1.name, this.chartErrorRateData.item2.name, this.chartErrorRateData.item3!.name],
        datasets: [{
          data: [this.chartErrorRateData.item1.value, this.chartErrorRateData.item2.value, this.chartErrorRateData.item3!.value],
          backgroundColor: [
            '#84c36c', /* grün */
    
            '#f7b731', /* gelb */
            '#d40c14', /* rot */

          ],
          hoverBackgroundColor: [
            '#5ca43c',

            '#f39c12',
            '#bc0404',
          ],
          hoverOffset: 0
        }],
      },
      options: {
        aspectRatio: 0.75,
        responsive: true,
        maintainAspectRatio: true,
        events: ['mousemove', 'mouseout', 'touchstart', 'touchmove'],
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
            },
          },
          datalabels: {
            color: 'white',
            font: {
              size: 13,
              weight: 'bold',
            },
            formatter: function (value: number, context: any) {
              const dataPoints = context.chart.data.datasets[0].data;
              function totalSum(total: number, datapoint: number) {
                return total + datapoint;
              }
              const totalValue = dataPoints.reduce(totalSum, 0);
              const percentageValue = (value / totalValue * 100).toFixed(1);

              return ` ${percentageValue}%`;
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  }

  public createChartWorkload() {
    this.chartError = new Chart('canvasWorkload', {
      type: 'doughnut',

      data: {
        labels: [this.chartWorkloadData.item1.name, this.chartWorkloadData.item2.name],
        datasets: [{
          data: [this.chartWorkloadData.item1.value, this.chartWorkloadData.item2.value],
          backgroundColor: [
            '#84c36c',
            '#d40c14'
          ],
          hoverBackgroundColor: [
            '#5ca43c',
            '#bc0404'
          ],
          hoverOffset: 0
        }],
      },
      options: {
        aspectRatio: 0.75,
        responsive: true,
        maintainAspectRatio: true,
        events: ['mousemove', 'mouseout', 'touchstart', 'touchmove'],
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
            },
          },
          datalabels: {
            color: 'white',
            font: {
              size: 13,
              weight: 'bold',
            },
            formatter: function (value: number, context: any) {
              const dataPoints = context.chart.data.datasets[0].data;
              function totalSum(total: number, datapoint: number) {
                return total + datapoint;
              }
              const totalValue = dataPoints.reduce(totalSum, 0);
              const percentageValue = (value / totalValue * 100).toFixed(1);

              return ` ${percentageValue}%`;
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  }
}
